/**
 * Dictionnaire extensible de traduction des codes d'erreur bruts Keycloak
 * (champ `error` des évènements `*_ERROR` de l'historique) vers des libellés FR
 * compréhensibles par l'utilisateur.
 *
 * Pour ajouter une traduction, il suffit d'ajouter une entrée ci-dessous.
 * Les codes non mappés retombent sur un libellé générique.
 */
export const KEYCLOAK_ERROR_LABELS: Record<string, string> = {
  invalid_user_credentials: 'Mot de passe incorrect',
  user_not_found: 'Utilisateur introuvable',
  user_disabled: 'Compte désactivé',
  user_temporarily_disabled: 'Compte temporairement bloqué',
  account_disabled: 'Compte désactivé',
  invalid_token: 'Jeton invalide',
  expired_code: 'Code expiré',
  session_expired: 'Session expirée',
  invalid_code: 'Code invalide',
  rejected_by_user: 'Refusé par l’utilisateur',
  not_allowed: 'Action non autorisée',
  invalid_client_credentials: 'Identifiants client invalides',
  identity_provider_login_failure: 'Échec de connexion via le fournisseur d’identité',
  invalid_redirect_uri: 'URL de redirection invalide',
  access_denied: 'Accès refusé',
}

export const GENERIC_KEYCLOAK_ERROR_LABEL = 'Échec de la connexion'

/**
 * Traduit un code d'erreur Keycloak en libellé FR.
 * Retourne un libellé générique (avec le code brut en indice) si le code est inconnu.
 */
export const translateKeycloakError = (errorCode?: string | null): string => {
  if (!errorCode) {
    return GENERIC_KEYCLOAK_ERROR_LABEL
  }

  const normalized = errorCode.trim().toLowerCase()
  return KEYCLOAK_ERROR_LABELS[normalized] ?? GENERIC_KEYCLOAK_ERROR_LABEL
}
